import {REGISTRO_ERROR, 
    REGISTRO_EXITOSO,
    RESET_STATE,
    LOGIN_EXITOSO,
    LOGIN_ERROR,
    CERRAR_SESION,
    OBTENER_USUARIO,
    FACEBOOK_LOGIN,
    AGREGAR_CARRITO,
    ERROR_AGREGAR_CARRITO,
    ELIMINAR_CARRITO,
    ERROR_ELIMINAR_CARRITO,
    VER_CARRITO,
    ERROR_VER_CARRITO,
    PRECIO_FINAL,
    AGREGAR_PEDIDO,
    AGREGAR_PEDIDO_ERROR,
    OBTENER_PEDIDO_CLIENTE,
    OBTENER_PEDIDO_CLIENTE_ERROR,
    ELIMINAR_PEDIDO,
    ELIMINAR_PEDIDO_ERROR
} from '../../types/index';

export default (state , action )  =>{
    switch (action.type) {
        case REGISTRO_EXITOSO :
            return {
                ...state,
                autenticado : false,
                mensaje : action.payload,
                registrado : true
            }
 
        case REGISTRO_ERROR :
            localStorage.removeItem('token')
            return {
                ...state,
                token : null,
                mensaje : action.payload,
                error : true,
            }
            
        case RESET_STATE : 
            return {
                ...state,
                mensaje : null,
                error : false,
                registrado  : null
            }
        case FACEBOOK_LOGIN:
        case LOGIN_EXITOSO :
            localStorage.setItem('token' , action.payload)
            return {
                ...state,
                error : null,
                token : action.payload,
                cargando : false,
                
            }
        case OBTENER_USUARIO : 
            return {
                ...state,
                cliente : action.payload,
                autenticado : true,
                cargando : false
            }
        case LOGIN_ERROR :
            localStorage.removeItem('token');
            
            return {
                ...state,
                mensaje : action.payload,
                error : true,
                cliente : null,
                autenticado : null,
                cargando : false,
                
            }
        case CERRAR_SESION : 
            localStorage.removeItem('token');

            return {
                ...state,
                autenticado : null,
                cliente : null,
                mensaje : null,
                registrado: false,
                error : false,
                cargando : true,
                token: null
            }
        case AGREGAR_PEDIDO : 
        case ELIMINAR_CARRITO:
        case AGREGAR_CARRITO : 
            return {
                ...state,
                mensaje : action.payload
            }
        case ELIMINAR_PEDIDO_ERROR :
        case OBTENER_PEDIDO_CLIENTE_ERROR:
        case AGREGAR_PEDIDO_ERROR:    
        case ERROR_ELIMINAR_CARRITO:
        case ERROR_VER_CARRITO :
        case ERROR_AGREGAR_CARRITO : 
            return {
                ...state,
                mensaje : action.payload,
                error : true
            }    
        case VER_CARRITO : {
            return {
                ...state,
                carrito : action.payload
            }
        }
        case PRECIO_FINAL : 
            return {
                ...state,
                total_carrito : action.payload
            }
       
        case OBTENER_PEDIDO_CLIENTE:
            
            return {
                ...state,
                pedido : action.payload,
                
            }   
        case ELIMINAR_PEDIDO :
            return {
                ...state,
                pedido : null,
                mensaje : action.payload
            }

        default:
            return state;
    }
}